import { Months } from "@/app/reports/utils/enums";

const getMonthColumns = () => {
  const columns = Object.keys(Months).map((monthKey) => ({
    title: Months[monthKey],
    dataIndex: monthKey,
    key: monthKey,
    width: 100,
  }));

  return columns;
};

export const abandonedColumns = [
  {
    title: "Tramo",
    dataIndex: "tramo",
    key: "tramo",
    width: 120,
    ellipsis: true,
    fixed: "left",
  },
  ...getMonthColumns(),
];
